/* =========================================================
   Ankit START - DFW BXGY Registry
   File: assets/dfw-bxgy-registry.js

   Purpose
   ---------------------------------------------------------
   - Collect BXGY configs rendered by Liquid
   - Deduplicate product entries
   - Build one global registry
   - Feed registry into BXGY Engine

   Output
   ---------------------------------------------------------
   window.DFWBXGY_REGISTRY

   Example
   ---------------------------------------------------------
   {
      "8740895752360":[
         {buy_qty:15,free_qty:1},
         {buy_qty:25,free_qty:2}
      ]
   }

   Notes
   ---------------------------------------------------------
   - Liquid prints .dfw-bxgy-entry JSON blocks
   - Registry converts them into one object
   - Engine reads registry instead of DOM

   ========================================================= */

(function(){

'use strict';

if(window.DFWBXGY_REGISTRY) return;

/* =========================================================
   Registry Storage
   ========================================================= */

var REGISTRY = {};

/* =========================================================
   Helpers
   ========================================================= */

function safeParse(text){

  try{
    return JSON.parse(text);
  }
  catch(e){
    return null;
  }

}

function normalizeDeal(deal){

  if(!deal) return null;

  var buy = Number(deal.buy_qty);
  var free = Number(deal.free_qty);

  if(!buy || !free) return null;

  return {
    buy_qty: buy,
    free_qty: free
  };

}

function registerProduct(productId,deals){

  if(!productId) return;

  if(!REGISTRY[productId]){
    REGISTRY[productId] = [];
  }

  deals.forEach(function(d){

    var normalized = normalizeDeal(d);

    if(!normalized) return;

    REGISTRY[productId].push(normalized);

  });

}

/* =========================================================
   Scan DOM for configs
   ========================================================= */

function scanConfigs(root){

  var scope = root || document;

  var nodes = scope.querySelectorAll('.dfw-bxgy-entry');

  if(!nodes.length) return;

  nodes.forEach(function(node){

    if(node.dataset.dfwRegistered === "true") return;

    var parsed = safeParse(node.textContent);

    if(!parsed) return;

    registerProduct(parsed.product_id,parsed.deals || []);

    node.dataset.dfwRegistered = "true";

  });

}

/* =========================================================
   Public Registry Builder
   ========================================================= */

function buildRegistry(){

  REGISTRY = {};

  scanConfigs();

  window.DFWBXGY_REGISTRY = REGISTRY;

  document.dispatchEvent(new CustomEvent('dfw:bxgy-registry-ready',{
    detail:{registry:REGISTRY}
  }));

}

/* =========================================================
   DOM Mutation Support
   ========================================================= */

var OBSERVER;

function watchDOM(){

  if(OBSERVER) return;

  OBSERVER = new MutationObserver(function(mutations){

    var relevant = mutations.some(function(m){

      return Array.prototype.some.call(m.addedNodes,function(node){

        if(!node || node.nodeType !== 1) return false;

        if(node.matches && node.matches('.dfw-bxgy-entry')) return true;

        if(node.querySelector && node.querySelector('.dfw-bxgy-entry')) return true;

        return false;

      });

    });

    if(relevant){

      scanConfigs();

      window.DFWBXGY_REGISTRY = REGISTRY;

    }

  });

  OBSERVER.observe(document.body,{
    childList:true,
    subtree:true
  });

}

/* =========================================================
   Init
   ========================================================= */

function init(){

  buildRegistry();

  watchDOM();

}

if(document.readyState === 'loading'){
  document.addEventListener('DOMContentLoaded',init);
}
else{
  init();
}

/* =========================================================
   Public API
   ========================================================= */

window.DFWBXGY_REGISTRY_API = {

  getRegistry:function(){
    return REGISTRY;
  },

  rebuild:function(){
    buildRegistry();
  },

  scan:function(root){
    scanConfigs(root);
  }

};

})();

/* =========================================================
   Ankit END - DFW BXGY Registry
   ========================================================= */